export default __webpack_public_path__ + "static/media/2.0c0b99e4.jpg";